document.addEventListener("DOMContentLoaded", function () {
    var slider = document.querySelector(".blog_textblock-slider--section .blog_textblock-slider-wrapper");

    if (!slider) return; // Falls kein Slider vorhanden ist, abbrechen

    var flickityInstance;

    function initFlickity() {
        if (window.innerWidth < 768) {
            if (!flickityInstance) {
                flickityInstance = new Flickity(slider, {
                    pageDots: true,
                    draggable: true,
                    cellAlign: "center",
                    prevNextButtons: false,
                    contain: true,
                    autoPlay: false,
                    adaptiveHeight: true,
                    cellSpacing: 16
                });
            }
        } else {
            if (flickityInstance) {
                flickityInstance.destroy(); // Deaktiviere Flickity auf Desktop
                flickityInstance = null;
            }
        }
    }

    initFlickity(); // Initialisieren beim Laden
    window.addEventListener("resize", initFlickity); // Aktualisieren beim Fenster-Resize
});
